import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/logo/icon-h@2x.png';
import LogoBig from '../../assets/images/logo/logo-h@3x.png';
import { isAR, lang, setLanguage } from '../../lang';
import { DEFAULT_LANGUAGE } from '../../common';
import Modal from 'react-modal';
import close from '../../assets/images/icons/x_icn.svg';
import colorLogo from '../../assets/images/logo/logo-h@2x.png';
import windowSize from 'react-window-size';
import instap from '../../assets/images/footer-icons/instagram-icn.svg';
import twitterp from '../../assets/images/footer-icons/twitter-icn-green.svg';
import { withTranslation } from 'react-i18next';
import Language from './language.jsx';
import LanguageButton from './LanguageButton.jsx';

Modal.setAppElement('#root');

class NavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageStatus: 'loading',
            language: DEFAULT_LANGUAGE,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            showModal: false,
        };

        setLanguage(DEFAULT_LANGUAGE);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    // const NavBar = ({ big, center, autism, careers, blog, media }) => {

    handleOpenModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };

    render() {
        const {
            big,
            center,
            autism,
            careers,
            blog,
            media,
            t,
            i18n,
        } = this.props;
        return (
            <div>
                <nav
                    className={`${
                        big ? 'big-logo-top' : ''
                    } navbar navbar-expand-lg navbar-light fixed-top ace-nav ${i18n.language === 'en' ? 'en-ace-nav' : ''}`}
                >
                    <a href='/'>
                        {big ? (
                            <img
                                src={LogoBig}
                                alt='logo'
                                className={`${
                                    center ? 'center-logo' : ''
                                } logo-inverted big-logo-img logo`}
                            />
                        ) : (
                            <img
                                src={Logo}
                                alt='logo'
                                className='logo logo-inverted'
                            />
                        )}
                    </a>
                    {this.state.width > 999 ? (
                        <div
                            className='collapse navbar-collapse'
                            id='navbarSupportedContent'
                        >
                            <ul
                                className={`${
                                    big ? 'logo-big' : ''
                                } navbar-nav nav-inverted`}
                            >
                                <li
                                    className={`nav-item-inverted ${
                                        center ? 'active-link' : ''
                                    }`}
                                >
                                    <Link
                                        to='/center'
                                        className='nav-link-inverted'
                                    >
                                        {t('nav.who')}
                                    </Link>
                                    <hr></hr>
                                </li>
                                <li
                                    className={`nav-item-inverted ${
                                        autism ? 'active-link' : ''
                                    }`}
                                >
                                    <Link
                                        to='/autism'
                                        className='nav-link-inverted'
                                    >
                                        {t('nav.autism')}
                                    </Link>
                                    <hr></hr>
                                </li>
                                <li
                                    className={`nav-item-inverted ${
                                        blog ? 'active-link' : ''
                                    }`}
                                >
                                    <Link
                                        to='/blog'
                                        className='nav-link-inverted'
                                    >
                                        {t('nav.articles')}
                                    </Link>
                                    <hr></hr>
                                </li>
                                <li
                                    className={`nav-item-inverted ${
                                        media ? 'active-link' : ''
                                    }`}
                                >
                                    <Link
                                        to='/media'
                                        className='nav-link-inverted'
                                    >
                                        {t('nav.media')}
                                    </Link>
                                    <hr></hr>
                                </li>
                                <li
                                    className={`nav-item-inverted ${
                                        careers ? 'active-link' : ''
                                    }`}
                                >
                                    <Link
                                        to='/careers'
                                        className='nav-link-inverted'
                                    >
                                        {t('nav.careers')}
                                    </Link>
                                    <hr></hr>
                                </li>
                                <Language inverted />
                            </ul>
                            <ul className='navbar-nav nv'>
                                <li>
                                    <Link to='/register/child'>
                                        <button
                                            className={`register-btn ${
                                                big
                                                    ? 'big-inverted-nav-btn nv'
                                                    : 'inverted-nav-btn'
                                            }`}
                                        >
                                            {t('nav.register')}
                                        </button>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    ) : (
                        <div>
                            <button
                                className='navbar-toggler dark-toggler'
                                type='button'
                                onClick={this.handleOpenModal}
                            >
                                <span
                                    className={`navbar-toggler-icon dark-icon ${
                                        i18n.language === 'en' ? 'flip' : ''
                                    }`}
                                ></span>
                            </button>
                            <Modal
                                isOpen={this.state.showModal}
                                contentLabel='nav'
                                className='nav-collapse-modal'
                                overlayClassName='modal-overlay nav-modal-overlay'
                                onRequestClose={this.handleCloseModal}
                            >
                                <button
                                    className='close-modal'
                                    type='button'
                                    onClick={this.handleCloseModal}
                                >
                                    <img src={close} />
                                </button>

                                <ul
                                    className={`navbar-nav ${
                                        this.props.first === false
                                            ? 'navbar-nav-small'
                                            : 'navbar-nav-normal'
                                    }`}
                                >
                                    <li className='nav-item'>
                                        <Link
                                            to='/'
                                            className='nav-link nav-img'
                                        >
                                            <img src={colorLogo} />
                                        </Link>
                                    </li>

                                    <li
                                        className={`nav-item-inverted ${
                                            center ? 'active-link' : ''
                                        }`}
                                    >
                                        <Link
                                            to='/center'
                                            className='nav-link nav-modal'
                                        >
                                            {t('nav.who')}
                                        </Link>
                                        <hr></hr>
                                    </li>
                                    <li
                                        className={`nav-item-inverted ${
                                            autism ? 'active-link' : ''
                                        }`}
                                    >
                                        <Link
                                            to='/autism'
                                            className='nav-link nav-modal'
                                        >
                                            {t('nav.autism')}
                                        </Link>
                                        <hr></hr>
                                    </li>
                                    <li
                                        className={`nav-item-inverted ${
                                            blog ? 'active-link' : ''
                                        }`}
                                    >
                                        <Link
                                            to='/blog'
                                            className='nav-link nav-modal'
                                        >
                                            {t('nav.articles')}
                                        </Link>
                                        <hr></hr>
                                    </li>
                                    <li
                                        className={`nav-item-inverted ${
                                            media ? 'active-link' : ''
                                        }`}
                                    >
                                        <Link
                                            to='/media'
                                            className='nav-link nav-modal'
                                        >
                                            {t('nav.media')}
                                        </Link>
                                        <hr></hr>
                                    </li>
                                    <li
                                        className={`nav-item-inverted ${
                                            careers ? 'active-link' : ''
                                        }`}
                                    >
                                        <Link
                                            to='/careers'
                                            className='nav-link nav-modal'
                                        >
                                            {t('nav.careers')}
                                        </Link>
                                        <hr></hr>
                                    </li>
                                </ul>
                                <ul className='navbar-nav'>
                                    <li>
                                        <Link to='/register/child'>
                                            <button className='register-btn inverted-nav-btn'>
                                                {t('nav.register')}
                                            </button>
                                        </Link>
                                    </li>
                                </ul>
                                <ul className='navbar-nav'>
                                    <li>
                                        <LanguageButton />
                                    </li>
                                </ul>
                                <ul className='navbar-nav nav-social'>
                                    <li>
                                        <a
                                            href='https://twitter.com/acesaudiorg'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img src={twitterp} alt='twitter' />
                                        </a>
                                        <a
                                            href='https://www.instagram.com/acesaudiorg'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img src={instap} alt='instagram' />
                                        </a>
                                    </li>
                                </ul>
                            </Modal>
                        </div>
                    )}
                </nav>
            </div>
        );
    }
}

export default withTranslation()(windowSize(NavBar));
